const API = process.env.REACT_APP_BACKEND_URL;

export function trackVisit() {
  try {
    if (sessionStorage.getItem("visited")) return;
    sessionStorage.setItem("visited", "1");
    fetch(`${API}/api/track/visit`, { method: "POST", keepalive: true }).catch(
      () => {},
    );
  } catch (e) {
    /* le suivi ne doit jamais casser la page */
  }
}

export function trackClick(restaurantId) {
  try {
    fetch(`${API}/api/track/click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ restaurant_id: restaurantId }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* le suivi ne doit jamais casser la page */
  }
}
